/**
 * L'état d'interface de « Mon compte », pur : le menu de l'avatar (et ses deux boîtes), la feuille
 * du choix du titre, le titre en cours d'envoi, et l'avis d'un geste qui n'est pas passé.
 */
export type AvatarMenuStep = "closed" | "menu" | "confirm-reset" | "mobile-only"

export type StudentAccountUiState = {
    avatarStep: AvatarMenuStep
    titleOpen: boolean
    /** Le titre envoyé, en attente du serveur. */
    savingTitleId: string | number | null
    /** Un geste qui n'est pas passé (avatar, titre). */
    notice: string | null
}

export type StudentAccountUiAction =
    | { type: "SET_AVATAR_STEP"; step: AvatarMenuStep }
    | { type: "OPEN_TITLE" }
    | { type: "CLOSE_TITLE" }
    | { type: "START_TITLE"; id: string | number }
    | { type: "TITLE_SAVED" }
    | { type: "FAILED"; message: string }
    | { type: "DISMISS_NOTICE" }

export const initialStudentAccountUiState: StudentAccountUiState = {
    avatarStep: "closed",
    titleOpen: false,
    savingTitleId: null,
    notice: null,
}

export function studentAccountUiReducer(
    state: StudentAccountUiState,
    action: StudentAccountUiAction
): StudentAccountUiState {
    switch (action.type) {
        case "SET_AVATAR_STEP":
            return { ...state, avatarStep: action.step }
        case "OPEN_TITLE":
            return { ...state, titleOpen: true }
        case "CLOSE_TITLE":
            // Pendant un envoi la feuille ne se ferme pas : la réponse la refermera.
            return state.savingTitleId != null ? state : { ...state, titleOpen: false }
        case "START_TITLE":
            return { ...state, savingTitleId: action.id }
        case "TITLE_SAVED":
            // `ChooseTitleModal` : le titre posé, la feuille se referme.
            return { ...state, savingTitleId: null, titleOpen: false }
        case "FAILED":
            // L'échec d'un titre laisse la feuille ouverte : l'élève peut en choisir un autre.
            return { ...state, savingTitleId: null, notice: action.message }
        case "DISMISS_NOTICE":
            return { ...state, notice: null }
        default:
            return state
    }
}
